import React from "react"

const VendorTableTitles = () => {
  return (
    <div className="grid-active-contracts-titles">
      <div className="flex col">
        <span className="color-gray font-14px ">VENDORS</span>
      </div>
      <div className="flex col">
        <span className="color-gray font-14px ">NUMBER OF CONTRACTS</span>
      </div>
      <div className="flex col">
        <span className="color-gray font-14px ">ACTIVE CONTRACT</span>
      </div>
      <div className="flex col">
        <span className="color-gray font-14px ">TOTAL VALUE</span>
      </div>
    </div>
  )
}

export default VendorTableTitles
